import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  collapse: {
    '.ant-collapse-header': {
      borderRadius: '0 !important'
    }
  },
  card: {
    '.ant-card-body': {
      padding: 0
    }
  },
  tag: {
    border: 0,
    backgroundColor: token.lightGrey.lightGrey1,
    borderRadius: 16,
    padding: '4px 10px 4px 12px'
  },
  treatmentTypeTag: {
    border: 0,
    backgroundColor: token.primary.primary2,
    color: token.colorWhite,
    borderRadius: 16,
    padding: '4px 10px 4px 12px'
  }
}))
